<nz-page-header
  [nzBackIcon]="!componentModel.backIcon ? null : ''"
  (nzBack)="goToList()"
>
  <nz-page-header-title>
    <span>
      {{ componentModel.pageTitle | translate }}
    </span>
  </nz-page-header-title>
  <nz-page-header-extra>
    <nz-space nzDirection="horizontal">
      <ng-container *ngIf="showLanguage">
        <nz-select
          *nzSpaceItem
          style="width: 150px"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="selectedLanguage"
          [nzCustomTemplate]="optionTemplate"
          (ngModelChange)="changeLanguage()"
        >
          <nz-option
            *ngFor="let language of languages"
            [nzValue]="language.Code"
            [nzLabel]="language.Label"
          >
          </nz-option>
        </nz-select>
        <ng-template #optionTemplate let-selected>
          <i class="fal fa-globe"></i> {{ selected.nzLabel  | translate}}
        </ng-template>
      </ng-container>
      <ng-container *ngIf="showCancel">
        <ng-container *isAuthorized="'Admin,Editor'">
          <button *nzSpaceItem nz-button nzType="default" (click)="goToList()">
            {{ componentModel.cancelButtonTitle | translate  }}
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="showSecondary">
        <button
          *nzSpaceItem
          nz-button
          nzType="default"
          (click)="secondaryButtonClicked.emit('')"
        >
          {{ componentModel.secondaryButtonTitle ||'' | translate  }}
        </button>
      </ng-container>
      <ng-container *isAuthorized="'Admin,Editor'">
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          type="button"
          (click)="saveButtonClicked.emit('')"
          [disabled]="submitButtonDisabled"
        >
          {{ componentModel.saveButtonTitle | translate   }}
        </button>
      </ng-container>
      <ng-content></ng-content>
    </nz-space>
  </nz-page-header-extra>
  <!-- <nz-breadcrumb nz-page-header-breadcrumb>
    <ng-container *ngFor="let breadCrumbItem of componentModel.breadCrumbPath">
      <nz-breadcrumb-item *ngIf="breadCrumbItem.routerLink == null">
        {{ breadCrumbItem.label }}
      </nz-breadcrumb-item>
      <nz-breadcrumb-item *ngIf="breadCrumbItem.routerLink != null">
        <a [routerLink]="breadCrumbItem.routerLink">
          {{ breadCrumbItem.label }}
        </a>
      </nz-breadcrumb-item>
    </ng-container>
  </nz-breadcrumb> -->
</nz-page-header>
